import { useSyncExternalStore } from "react";

/** Tailwind's `md`: below it is a phone. */
const WIDE = "(min-width: 48rem)";

const subscribe = (onChange: () => void) => {
  const query = window.matchMedia(WIDE);
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
};

/**
 * Whether the screen is `md` or wider, known on the first render (unlike
 * `useIsMobile`), so a layout that differs on a phone doesn't flash the other one.
 */
export function useWide(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(WIDE).matches,
    () => true,
  );
}
